import { API, get } from "../../../config";

/**  
 * * Start: Incident Detail API
 * @param {String} incidentId (Incident uuid)
 * @return {JSON}  Incident Record data of that id
**/
export const getIncidentDetail = async (incidentId) => {
  try {
    const { data } = await get(`${API.INCIDENT_DETAILS}/` + incidentId);
    return data.data;
  } catch (e) {
    return null;
  }
};

// * End: Incident Detail API
